export const MetricCard = ({ title, value, icon, color, testId }) => {
  const colorClasses = {
    success: 'text-[#0A7029] bg-[#0A7029]/5',
    danger: 'text-[#E53935] bg-[#E53935]/5',
    primary: 'text-[#002FA7] bg-[#002FA7]/5',
    warning: 'text-[#D97706] bg-[#D97706]/5',
  };

  return (
    <div className="bg-white p-6 border-r border-b border-[#E5E5E0] last:border-r-0" data-testid={testId}>
      <div className="flex items-start justify-between mb-3">
        <span className="text-sm text-[#666660] font-medium">{title}</span>
        <div className={`p-2 rounded-sm ${colorClasses[color]}`}>
          {icon}
        </div>
      </div>
      <div className={`currency text-2xl lg:text-3xl font-bold ${colorClasses[color].split(' ')[0]}`} data-testid={`${testId}-value`}>
        {value}
      </div>
    </div>
  );
};

export default MetricCard;
